import { Floor } from "@pdfking/math"

import { Map } from "../functions/Map"
import { RandomFloat } from "./RandomFloat"

/**
 * Generates pseudo-random integers.
 *
 * Uses RandomFloat with floor to produce integers in inclusive range [min, max].
 * Same seed produces same sequence. If no seed provided, uses random seed.
 *
 * @param n - Number of values to generate
 * @param min - Minimum value (inclusive)
 * @param max - Maximum value (inclusive)
 * @param seed - Random seed for reproducibility (optional, random if not provided)
 * @returns Iterable of random integers in [min, max]
 *
 * @example
 * ```ts
 * import { RandomInteger } from "@pdfking/tfunc"
 *
 * Array.from(RandomInteger(10, 1, 6, 123))
 * // [2, 3, 1, 2, 3, 4, 3, 2, 1, 4]
 *
 * Array.from(RandomInteger(10, 1, 6)) // truly random
 * ```
 */
export const RandomInteger = (
  n: number,
  min: number,
  max: number,
  seed?: number
): Iterable<number> => Map(Floor, RandomFloat(n, min, max + 1, seed))
